// ============================================================
//  SEO data: dedicated service "money pages" + service-area cities
//  Built from Miller & Miller SEO Keyword List
// ============================================================

export const SITE = {
  url: "https://millermillerservices.com",
  name: "Miller & Miller Services LLC",
  ogImage: "/photos/stock-1.jpg",
  region: "Brevard County",
  primaryCity: "Melbourne, FL",
};

// ---------- 5 dedicated service pages ----------
export const SEO_SERVICES = [
  {
    slug: "pool-screen-enclosures",
    path: "/pool-screen-enclosures",
    nav: "Pool Screen Enclosures",
    h1: "Pool Screen Enclosures in Melbourne, FL",
    metaTitle: "Pool Screen Enclosures Melbourne FL | Pool Cages | Miller & Miller",
    metaDescription:
      "Custom pool screen enclosures & pool cage installation in Melbourne, FL. Aluminum pool enclosures built for the Space Coast by a licensed, family-owned contractor. Free estimates.",
    keywords: [
      "pool screen enclosure", "pool enclosure", "pool cage", "pool cage installation",
      "custom pool enclosure", "aluminum pool enclosure", "screened pool enclosure",
      "pool enclosure contractor Melbourne FL", "pool cage company near me",
    ],
    image: "/photos/stock-1.jpg",
    eyebrow: "Pool Screen Enclosures",
    intro:
      "A custom pool screen enclosure - often called a pool cage - is the single best upgrade for enjoying your Florida pool year-round. Our aluminum pool enclosures keep out insects, leaves, and debris while adding shade, privacy, and value to your Melbourne, FL home.",
    benefits: [
      { title: "Less Maintenance", text: "Dramatically reduce cleaning time and chemical usage by keeping leaves, pollen, and debris out of your pool." },
      { title: "Insect & Pest Defense", text: "High-density 20/20 no-see-um mesh stops even the smallest biting insects, frogs, and wasps." },
      { title: "Storm-Rated Aluminum", text: "Heavy-gauge extruded framing and concrete tie-downs engineered to meet Florida Building Code wind loads." },
      { title: "Custom Architecture", text: "Mansard, gable, and dome styles designed to complement your home and roofline." },
    ],
    features: ["Pool cage installation & replacement", "Custom mansard, gable & dome designs", "Stainless steel fasteners", "No-see-um mesh options"],
    faqs: [
      { q: "How much does a pool screen enclosure cost?", a: "Cost depends on size, style, and mesh selection. We provide a fast, free, no-obligation estimate tailored to your exact pool and budget." },
      { q: "How long does pool cage installation take?", a: "Most pool enclosures are completed in just a few days once permits are secured - we handle the entire permitting process for you." },
      { q: "Do you build custom pool enclosures?", a: "Yes. Every pool cage is custom-engineered to your deck layout, home style, and preferences." },
    ],
    related: ["screen-enclosures", "pool-screen-repair-rescreening"],
  },
  {
    slug: "screen-enclosures",
    path: "/screen-enclosures",
    nav: "Screen & Lanai Enclosures",
    h1: "Screen & Lanai Enclosures in Melbourne, FL",
    metaTitle: "Screen Enclosures & Lanai Enclosures Melbourne FL | Miller & Miller",
    metaDescription:
      "Custom aluminum screen enclosures, screen rooms & lanai enclosures in Melbourne, FL. Expand your outdoor living space with a licensed, family-owned screen enclosure contractor.",
    keywords: [
      "screen enclosure", "screen enclosures", "screen room enclosure", "aluminum screen enclosure",
      "custom screen enclosure", "lanai screen enclosure", "screened lanai", "lanai enclosure",
      "elite screen enclosure", "screen enclosure contractor Melbourne FL",
    ],
    image: "/photos/lanai-elite.jpg",
    eyebrow: "Screen & Lanai Enclosures",
    intro:
      "Turn your backyard into a comfortable, bug-free extension of your home with a custom aluminum screen enclosure or lanai. Our screen rooms and elite lanai enclosures deliver indoor comfort with outdoor openness across the Space Coast.",
    benefits: [
      { title: "More Living Space", text: "Add a beautiful, usable outdoor room that makes your home feel bigger and more inviting." },
      { title: "Insect & Weather Defense", text: "Enjoy fresh air and sunshine while staying protected from bugs, rain, and harsh UV." },
      { title: "Fully Customizable", text: "Elite composite roofs, screen rooms, and lanai styles designed around how you live." },
      { title: "Built to Last", text: "Corrosion-resistant aluminum and stainless hardware engineered for coastal Florida." },
    ],
    features: ["Screen rooms & lanai enclosures", "Elite insulated-roof rooms", "Rescreening of existing lanais", "Custom sizing & styles"],
    faqs: [
      { q: "What is the difference between a lanai and a screen room?", a: "A lanai is typically a covered, screened outdoor area attached to the home, while a screen room can be a freestanding or attached screened structure. We build both, custom to your space." },
      { q: "What is an Elite Room?", a: "An Elite Room uses insulated composite roof panels for full thermal shade - a step above a standard screened porch and a great middle ground before a full sunroom." },
      { q: "Can you screen my existing lanai?", a: "Absolutely - we screen existing covered lanais and porches and can restore or upgrade older enclosures." },
    ],
    related: ["patio-porch-screen-enclosures", "pool-screen-enclosures"],
  },
  {
    slug: "patio-porch-screen-enclosures",
    path: "/patio-porch-screen-enclosures",
    nav: "Patio & Porch Screens",
    h1: "Patio & Porch Screen Enclosures in Melbourne, FL",
    metaTitle: "Patio & Porch Screen Enclosures Melbourne FL | Screened Patio | Miller & Miller",
    metaDescription:
      "Screened patios, porch screening & patio screen enclosures in Melbourne, FL. Enjoy shade, privacy, and bug-free outdoor living with a custom patio screen installation.",
    keywords: [
      "patio screen enclosure", "screened patio", "patio screening", "patio screen installation",
      "screened porch", "porch screening", "patio enclosure contractor", "custom patio screen enclosure",
    ],
    image: "/photos/mm-23.jpg",
    eyebrow: "Patio & Porch Screens",
    intro:
      "Screen an existing patio or porch - or build a brand-new screened patio enclosure - and reclaim your outdoor space. Our patio and porch screening keeps out insects and debris while preserving airflow, shade, and views.",
    benefits: [
      { title: "Bug-Free Comfort", text: "Relax outside without mosquitoes and no-see-ums ruining the evening." },
      { title: "Shade & UV Protection", text: "Cut down harsh sun and heat while keeping your view and breeze." },
      { title: "Added Living Space", text: "Create a comfortable spot for dining, lounging, and entertaining right outside your door." },
      { title: "Screen Existing Openings", text: "We screen existing covered patios and porches or build new enclosures from the ground up." },
    ],
    features: ["Screened patios & porches", "New patio screen enclosures", "Screen existing openings", "Custom doors & pet options"],
    faqs: [
      { q: "Can you screen my existing covered porch?", a: "Yes - screening an existing covered patio or lanai is one of our most popular, fast-turnaround services." },
      { q: "How long does patio screening take?", a: "Most patio and porch screening projects are completed within a few days depending on size." },
      { q: "Do you offer pet-resistant screen?", a: "Yes, we offer heavy-duty pet-resistant mesh and reinforced kick plates on request." },
    ],
    related: ["screen-enclosures", "pool-screen-repair-rescreening"],
  },
  {
    slug: "pool-screen-repair-rescreening",
    path: "/pool-screen-repair-rescreening",
    nav: "Rescreening & Repair",
    h1: "Pool Screen Repair & Rescreening in Melbourne, FL",
    metaTitle: "Pool Screen Repair & Rescreening Melbourne FL | Miller & Miller",
    metaDescription:
      "Pool cage rescreening, screen enclosure repair & structural restoration in Melbourne, FL. Fix torn screens, rusted hardware & storm damage. Fast, reliable rescreen service.",
    keywords: [
      "pool screen repair", "pool cage rescreening", "screen enclosure repair", "rescreening",
      "pool cage repair", "screen repair Melbourne FL", "lanai rescreening", "patio screen repair",
    ],
    image: "/photos/mm-15.jpg",
    eyebrow: "Rescreening & Repair",
    intro:
      "Loose, saggy, or torn screen? Rusted hardware or storm damage? We specialize in full structural rescreening and pool cage restoration that makes your enclosure look and function like new - with upgraded fasteners for lasting durability.",
    benefits: [
      { title: "Full Rescreens", text: "Complete panel replacement to restore clear views and a fresh, tight finish." },
      { title: "Structural Restoration", text: "We upgrade to stainless fasteners and reinforce frames for long-term integrity." },
      { title: "Storm Damage Repair", text: "Fast repair of wind and debris damage to get your enclosure back in shape." },
      { title: "Tension & Tear Fixes", text: "Retension sagging screen and repair tears before they spread." },
    ],
    features: ["Full pool cage rescreens", "Screen panel & spline replacement", "Fastener & frame upgrades", "Storm damage restoration"],
    faqs: [
      { q: "Do you repair a single torn panel?", a: "We specialize in full structural rescreening and restorations rather than minor single-panel patches, which delivers a better, longer-lasting result." },
      { q: "How long does rescreening take?", a: "Many rescreens are completed in a single day depending on the size of the enclosure." },
      { q: "Can you upgrade my old hardware?", a: "Yes - we upgrade to corrosion-resistant stainless steel fasteners to prevent rust-bleeding and structural weakening." },
    ],
    related: ["pool-screen-enclosures", "screen-enclosures"],
  },
  {
    slug: "carports",
    path: "/carports",
    nav: "Carports",
    h1: "Carport Installation in Melbourne, FL",
    metaTitle: "Carport Installation Melbourne FL | Aluminum Carports | Miller & Miller",
    metaDescription:
      "Custom aluminum carport installation in Melbourne, FL. Durable, weather-resistant carports that protect your vehicles from sun, rain & storms. Free estimates from a local contractor.",
    keywords: [
      "carport installation", "aluminum carport", "custom carport", "carport contractor",
      "carport Melbourne FL", "metal carport", "carport builder near me",
    ],
    image: "/photos/carport.jpg",
    eyebrow: "Carports",
    intro:
      "Protect your vehicles, boats, and equipment from the harsh Florida sun and weather with a durable, custom aluminum carport. Built to last and sized to fit your property.",
    benefits: [
      { title: "Weather Resistance", text: "Shield vehicles from intense UV, heavy rain, and storm conditions." },
      { title: "Structural Longevity", text: "Corrosion-resistant aluminum engineered for coastal Florida durability." },
      { title: "Custom Sizing", text: "Designed to fit your driveway, RV, or boat with the coverage you need." },
      { title: "Adds Value", text: "A clean, functional upgrade that improves curb appeal and utility." },
    ],
    features: ["Custom aluminum carports", "Insulated roof options", "Boat & RV coverage", "Code-compliant tie-downs"],
    faqs: [
      { q: "Are your carports permitted and code-compliant?", a: "Yes - we handle permitting and build to meet Florida Building Code wind-load requirements." },
      { q: "Can I get a custom size?", a: "Absolutely. Carports are custom-sized to your property and what you need to cover." },
      { q: "How long does installation take?", a: "Most carport projects are completed quickly once permits are approved." },
    ],
    related: ["screen-enclosures", "patio-porch-screen-enclosures"],
  },
];

export const getSeoService = (slug) => SEO_SERVICES.find((s) => s.slug === slug);

// ---------- 12 Brevard County service-area cities ----------
export const SERVICE_AREAS = [
  { slug: "melbourne-fl", name: "Melbourne", full: "Melbourne, FL", zips: ["32901", "32904", "32935", "32940"],
    blurb: "Our home base. We build and service pool cages, screen enclosures, and patios throughout Melbourne - from Eau Gallie to the Melbourne waterfront.", nearby: ["West Melbourne", "Palm Bay", "Melbourne Beach"] },
  { slug: "west-melbourne-fl", name: "West Melbourne", full: "West Melbourne, FL", zips: ["32904", "32912"],
    blurb: "Serving West Melbourne neighborhoods with custom pool enclosures, screen rooms, and rescreening backed by strict adherence to local building codes.", nearby: ["Melbourne", "Palm Bay", "Viera"] },
  { slug: "palm-bay-fl", name: "Palm Bay", full: "Palm Bay, FL", zips: ["32905", "32907", "32908", "32909"],
    blurb: "Palm Bay's trusted screen enclosure team for new pool cages, patio screening, and structural rescreening - handling permits and HOA approvals for you.", nearby: ["West Melbourne", "Melbourne", "Malabar"] },
  { slug: "viera-fl", name: "Viera", full: "Viera, FL", zips: ["32940", "32955"],
    blurb: "Custom pool enclosures and lanai screening for Viera and Viera West homes, built to satisfy strict community design guidelines.", nearby: ["Rockledge", "Melbourne", "Cocoa"] },
  { slug: "rockledge-fl", name: "Rockledge", full: "Rockledge, FL", zips: ["32955", "32956"],
    blurb: "Rockledge homeowners rely on us for beautiful pool cages, screen rooms, and fast, reliable rescreening along the Indian River.", nearby: ["Viera", "Cocoa", "Merritt Island"] },
  { slug: "cocoa-fl", name: "Cocoa", full: "Cocoa, FL", zips: ["32922", "32926", "32927"],
    blurb: "Serving Cocoa and Cocoa area with durable aluminum enclosures, patio screening, and carports engineered for coastal weather.", nearby: ["Rockledge", "Merritt Island", "Titusville"] },
  { slug: "merritt-island-fl", name: "Merritt Island", full: "Merritt Island, FL", zips: ["32952", "32953"],
    blurb: "Merritt Island's choice for pool screen enclosures and lanai rescreening built to stand up to island wind and salt air.", nearby: ["Cocoa", "Rockledge", "Cocoa Beach"] },
  { slug: "satellite-beach-fl", name: "Satellite Beach", full: "Satellite Beach, FL", zips: ["32937"],
    blurb: "Beachside pool cages and screen enclosures for Satellite Beach - extra corrosion protection for oceanfront living.", nearby: ["Indian Harbour Beach", "Indialantic", "Melbourne"] },
  { slug: "indian-harbour-beach-fl", name: "Indian Harbour Beach", full: "Indian Harbour Beach, FL", zips: ["32937"],
    blurb: "Custom screen enclosures and rescreening for Indian Harbour Beach homes, built with coastal-grade materials.", nearby: ["Satellite Beach", "Indialantic", "Melbourne"] },
  { slug: "indialantic-fl", name: "Indialantic", full: "Indialantic, FL", zips: ["32903"],
    blurb: "Indialantic pool enclosures, screened patios, and lanai screening designed for elegant beachside outdoor living.", nearby: ["Melbourne Beach", "Indian Harbour Beach", "Melbourne"] },
  { slug: "melbourne-beach-fl", name: "Melbourne Beach", full: "Melbourne Beach, FL", zips: ["32951"],
    blurb: "Serving Melbourne Beach with premium pool cages and screen enclosures crafted for barrier-island durability.", nearby: ["Indialantic", "Melbourne", "Satellite Beach"] },
  { slug: "titusville-fl", name: "Titusville", full: "Titusville, FL", zips: ["32780", "32796"],
    blurb: "Titusville homeowners trust us for new pool screen enclosures, patio screening, and rescreening across North Brevard.", nearby: ["Cocoa", "Mims", "Port St. John"] },
];

export const getServiceArea = (slug) => SERVICE_AREAS.find((c) => c.slug === slug);
